var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tr", [
    _c("td", [
      _c(
        "a",
        {
          staticClass: "text-black font-sans-bold",
          attrs: { href: "#" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.editFestival.apply(null, arguments)
            },
          },
        },
        [_vm._v(_vm._s(_vm.festival.title))]
      ),
    ]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.festival.slug))]),
    _vm._v(" "),
    _c("td", [
      _c(
        "button",
        {
          staticClass: "font-sans-bold underline",
          on: {
            click: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.exportEvents.apply(null, arguments)
            },
          },
        },
        [_vm._v("Export Events")]
      ),
    ]),
    _vm._v(" "),
    _c("td", [
      _c(
        "button",
        {
          staticClass: "font-sans-bold underline",
          on: {
            click: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.syncFestivalEvents.apply(null, arguments)
            },
          },
        },
        [_vm._v("Resync Events")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }